module.exports = __webpack_public_path__ + "static/img/search_icon_1.9d44c472.png";